import { useSelector, useDispatch } from "react-redux";
import "./styles.css";
import { useLang } from "../../context/langProvider";
import { setUserField } from "../../redux/actions/subscriptionActions";

const FormUserSubscription = ({ role, onNext, onPrevious }) => {
  const dispatch = useDispatch();
  const { t } = useLang();

  // On récupère le state Redux
  const user = useSelector((state) => state.subscription.user);

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch(setUserField(name, value));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (user.password !== user.passwordRepeat) {
      alert(t("passwords-dont-match"));
      return;
    }

    console.log("Formulaire soumis", { ...user, role });
    onNext();
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>{t("identifiants")}</h2>

      <div className="input-form">
        <label htmlFor="email">{t("mail-address")}</label>
        <input
          type="email"
          id="email"
          name="email"
          value={user.email}
          onChange={handleChange}
          required
        />
      </div>

      <div className="input-form">
        <label htmlFor="password">{t("type-password")}</label>
        <input
          type="password"
          id="password"
          name="password"
          value={user.password}
          onChange={handleChange}
          required
        />
      </div>

      <div className="input-form">
        <label htmlFor="passwordRepeat">{t("repeat-password")}</label>
        <input
          type="password"
          id="passwordRepeat"
          name="passwordRepeat"
          value={user.passwordRepeat || ""}
          onChange={handleChange}
          required
        />
      </div>

      <div className="btns-container">
        <button type="button" onClick={onPrevious}>
          {t("previous")}
        </button>
        <button type="submit">{t("next")}</button>
      </div>
    </form>
  );
};

export default FormUserSubscription;
